import React, { useState, useEffect } from "react";
import AdminWrapper from "./AdminWrapper";
import SwitchMenuBar from "../../Components/SwitchMenuBar/SwitchMenuBar";
import { managerRegTable, managerBookingTable } from "../Statistics/statisticsTable";
import { API } from "../../API";
import { StylesStatistics } from "../Statistics/styled";
import CheckableButton from "../../Components/CheckableButton/CheckableButton";
import { Refresh } from "@mui/icons-material";
import CircularProgress from '@mui/material/CircularProgress';
import Modal from "../../Components/Modal/Modal";
import FormDatePicker from "../../Components/FormField/FormDatePicker";
import DatePicker from "react-datepicker"
import ConfirmButton from "../../Components/Buttons/ConfirmButton";

import moment from "moment";

const Report = () => {
  const [bookingData, setBookingData] = useState({});
  const [regData, setRegData] = useState({});
  const [begin, setBegin] = useState(moment().subtract(1, 'week').format('YYYY-MM-DD'));
  const [end, setEnd] = useState(moment().format('YYYY-MM-DD'));
  const [datepicker, setDatePicker] = useState(false);
  const [loading, setloading] = useState(true);
  const [period, setperiod] = useState('');

  useEffect(() => {
    getManagerReport();
  }, []);

  const DateRangePicker = ({ startDate, endDate, handleChange }) => {
    const [selectedStartDate, setSelectedStartDate] = useState(startDate);
    const [selectedEndDate, setSelectedEndDate] = useState(endDate);

    const handleStartDateChange = (date) => {
      setSelectedStartDate(date);
    };

    const handleEndDateChange = (date) => {
      setSelectedEndDate(date);
    };
    const confirmChange = (start,end) => {
      handleChange(start, end)
    }

    return (
      <div style={{ 
        height: '400px' ,
        width: '500px' 
        }}>
      <div>
        <label htmlFor="startDate">From: </label>
        <div className="form-group">
          <div className="input-icon">
            <DatePicker
              label="From"
              id="from_date"
              selected={selectedStartDate}
              onChange={handleStartDateChange}
              selectsStart
              startDate={selectedStartDate}
              endDate={selectedEndDate}
              placeholderText="Start Date"
              dateFormat="dd-MM-yyyy"
              popperClassName="some-custom-class"
              className={'form-control'}
            />
          </div>
        </div>
        <a>   </a>
        <label htmlFor="endtDate"> To: </label>
        <div className="form-group">
          <div className="input-icon">
            <DatePicker
              label="To"
              id="to_date"
              selected={selectedEndDate}
              onChange={handleEndDateChange}
              selectsEnd
              startDate={selectedStartDate}
              endDate={selectedEndDate}
              minDate={selectedStartDate}
              placeholderText="End Date"
              dateFormat="dd-MM-yyyy"
              popperClassName="some-custom-class"
              className={'form-control'}
            />
          </div>
        </div>
      </div>
      <div className="col-md-2 ">
        <ConfirmButton
          type="button"
          onClick={()=>{confirmChange(selectedStartDate,selectedEndDate)}}
        >
          Submit
        </ConfirmButton>
      </div>
      </div>
    );
  };

  const getManagerReport = async (begin,end) => {
    try {
      const startDate = begin ? begin : moment().subtract(1, 'week').format('YYYY-MM-DD')
      const endDate = end ? end : moment().format('YYYY-MM-DD')
      const { data } = await API.managerReport(startDate,endDate);
      setBookingData(data.data.booking);
      setRegData(data.data.registration);
      setBegin(data.data.start);
      setEnd(data.data.end);
      setloading(false)
      const diff = moment(data.data.end).diff(data.data.start, 'days');
      setperiod(diff === 7 ? 'Week' : `${diff}-days`)
    } catch (error) {
      console.log('getManagerReport ERR', error);
    }
  };

  const handleDateChange = (startDate, endDate) => {
    setDatePicker(false);
    setloading(true)
    getManagerReport(
      moment(startDate).format('YYYY-MM-DD'),
      moment(endDate).format('YYYY-MM-DD')
    )
  };

  const toggleDatePicker = () => {
    setDatePicker(!datepicker);
  };

  return (
    <AdminWrapper>
      {datepicker &&
        <Modal
          show={datepicker}
          className="book-teacher-modal"
          onClose={toggleDatePicker}
        >
          <DateRangePicker
            startDate={moment(begin).toDate()}
            endDate={moment(end).toDate()}
            handleChange={handleDateChange}
          />
        </Modal>
      }
      <SwitchMenuBar isViewAsTeacher />
      <StylesStatistics>
        <div className="body-main-page-JobList">
          <div className="d-flex flex-col items-center my-2">
            <p className="text-3xl font-bold mb-2">Manager Report</p>
            <div
              onClick={toggleDatePicker}
              style={{ cursor: 'pointer' }}
              onMouseOver={(e) => { e.target.style.color = 'rgba(54, 162, 235, 0.5)'; }}
              onMouseOut={(e) => { e.target.style.color = 'grey'; }}
            >
              {loading ? <CircularProgress size={20} color="inherit"/> 
                : <p className="text-2xl font-bold">{begin} TO {end}</p>
              }
            </div>
          </div>

          <div className="row">
            <div
              id='bookTable'
              className="col statistic-card">
              {managerBookingTable(bookingData,period)}
            </div>
          </div>
          <div className="row">
            <div
              id='regTable'
              className="col statistic-card">
              {managerRegTable(regData)}
            </div>
          </div>
        </div>
      </StylesStatistics>
    </AdminWrapper>
  );
};

export default Report;
